const REQUIRED_THEME_CLASS = "cui-theme";
const toThemeClass = (contentTheme, controlsTheme, suffix = "") => {
  if (contentTheme === controlsTheme) {
    const both = contentTheme;
    return both ? `${REQUIRED_THEME_CLASS} theme-${both}${suffix}` : void 0;
  }
  return [
    REQUIRED_THEME_CLASS,
    contentTheme ? `theme-${contentTheme}-content${suffix}` : void 0,
    controlsTheme ? `theme-${controlsTheme}-controls${suffix}` : void 0
  ].filter(Boolean).join(" ");
};
export {
  toThemeClass
};
//# sourceMappingURL=toThemeClass.js.map
